import React from 'react';
import { useTranslation } from '../../../context/LanguageContext';
import './ModalFooter.css';

const ModalFooter = ({ onCancel, onConfirm, loading, disabled }) => {
  const { t } = useTranslation();

  const handleCancel = (e) => {
    e.stopPropagation();
    if (!loading) {
      onCancel();
    }
  };

  return (
    <div className="modal-footer">
      <button 
        type="button"
        className="modal-button cancel-button" 
        onClick={handleCancel}
        disabled={loading}
      >
        {t('cashier.payment.actions.cancel')}
      </button>
      
      <button 
        type="button"
        className="modal-button confirm-button" 
        onClick={onConfirm}
        disabled={loading || disabled}
      >
        {loading ? 
          t('cashier.payment.actions.processing') :
          t('cashier.payment.checkout')
        }
      </button>
    </div>
  );
};

export default ModalFooter;
